import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Laura G.',
    quote: 'I went from living in a cloud of total confusion to regaining my mental sharpness in just 3 weeks. The supplements LLOYD recommends changed my life. I became that brilliant executive again, but with a much deeper connection to my son.',
    result: 'Regained professional focus in 21 days.'
  }, {
    name: 'Carla M.',
    quote: "I thought I'd never feel attractive or energized again. The Protocol taught me I could train my pelvic floor and my mind while playing with my baby. I've lost 10 lbs of inflammation and, for the first time in a year, I feel in control of my goals.",
    result: '-10 lbs and ended incontinence in 90 days.'
  }, {
    name: 'Sophia R.',
    quote: 'The Family Boundaries Guide was a game changer. I finally got my environment to actually support me instead of draining me. This book saved my mental health and my marriage.',
    result: '80% reduction in family stress.'
  }];
  return <section className="py-20 px-4 bg-cream-dark" data-id="element-183">
      <div className="max-w-6xl mx-auto" data-id="element-184">
        <div className="text-center mb-16" data-id="element-185">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brown mb-4" data-id="element-186">
            Real Mothers. Real Reconnection.
          </h2>
          <p className="text-lg text-brown-light font-body" data-id="element-187">
            Join thousands of women who have already reclaimed their identity.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-188">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-warm flex flex-col h-full relative" data-id="element-189">
              <div className="flex gap-1 mb-6 text-gold" data-id="element-190">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-191" />)}
              </div>

              <blockquote className="flex-grow mb-6" data-id="element-192">
                <p className="text-brown-light font-body italic leading-relaxed" data-id="element-193">
                  "{testimonial.quote}"
                </p>
              </blockquote>

              <div className="mt-auto pt-6 border-t border-cream-dark" data-id="element-194">
                <p className="font-heading font-bold text-brown text-lg mb-1" data-id="element-195">
                  — {testimonial.name}
                </p>
                <div className="bg-sage/10 text-sage-light px-3 py-2 rounded-lg inline-block text-sm font-medium" data-id="element-196">
                  Result: {testimonial.result}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}